import postalCodes from './postal-codes';

export default function postalCodeRegexChanger() {
  $('.js-pc-changer').on('change', function () {
    const target = $('.js-postcode');
    const country = $(this).val();
    if (postalCodes[country]) {
      target.prop({ pattern: postalCodes[country] });
    } else {
      target.prop({ pattern: '*' });
    }
    if (country && country !== 'Country') {
      window.checkItemValidity(target.get(0));
    }
  });
  if($('.js-pc-changer').length) {
    if($('.js-pc-changer').val()) {
      $('.js-pc-changer').trigger('change');
    }
  }
}
